// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class ControlAlertCommandMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_CONTROL_ALERT_COMMAND_MESSAGE, fieldSet);
    }
    getAlertId() {
        return this.getFieldValue(FieldsFactory.FIELD_ALERT_ID);
    }
    setAlertId(alertId) {
        this.setFieldValue(FieldsFactory.FIELD_ALERT_ID, alertId);
    }
    getAlertCommand() {
        return this.getFieldValue(FieldsFactory.FIELD_ALERT_COMMAND);
    }
    setAlertCommand(alertCommand) {
        this.setFieldValue(FieldsFactory.FIELD_ALERT_COMMAND, alertCommand);
    }
}
